import React, { Component } from 'react';
import logo from './images/face_small.jpg';
import CatLinks from './components/CatLinks';
import Feed from './components/Feed';
import Post from './components/Post';
import User from './components/User';
import Login from './components/Login';
import Register from './components/Register';
import ViewBlog from './components/ViewBlog';
import Admin from './components/Admin';
import MakePost from './components/MakePost';
import Extras from './components/Extras';
import AllBlog from './components/AllBlog';
import './App.css';
import {BrowserRouter as Router, Route, Link, Switch} from 'react-router-dom';
/* global firebase */
/* global $ */
/* global gtag */
let sara = firebase;
firebase = undefined;

// Written by Sam Inniss for MinusTheNegative.com

// TODO: symbols such as in http://localhost:3000/category/addiction
// Bigger "home" click target
// smaller "relevant to you" in cats and move up
// remove localhost from recapcha
// remove localhost from server
// verify email before posting anything
// capcha off screen on mobile
// disable console
// disable sara & jquery in console
// loading for login and register buttons
// prod versions of sara
// alert fade out
// handle 404s
// sara offs before ons


class App extends Component {
  constructor(props){
    super(props);
    
    var config = {
      apiKey: "AIzaSyAcy88qxP29LnUdj1DqAp7xIVS-vL9uIq0",
      authDomain: "minusthenegative-1fd3c.firebaseapp.com",
      databaseURL: "https://minusthenegative-1fd3c.firebaseio.com",
      projectId: "minusthenegative-1fd3c",
      storageBucket: "minusthenegative-1fd3c.appspot.com",
      messagingSenderId: "5293568406"
    };
    sara.initializeApp(config);
    
    this.state = {
      'posts_info': [],
      'posts_info_dict': {},
      'posts_info_loaded': false,
      'users': {},
      'users_loaded': false,
      'this_user': null,
      'this_user_loaded': false,
      'this_user_found': false,
      'blogs': [],
      'blogs_dict': {},
      'blogs_loaded': false,
      'firebase': sara,
      's': $,
    }
  }
  
  componentDidMount() {   
    sara.auth().onAuthStateChanged((user) => {
      if (user) {
        // User is signed in.
        //var displayName = user.displayName;
        //var email = user.email;
        //var emailVerified = user.emailVerified;
        //var photoURL = user.photoURL;
        //var isAnonymous = user.isAnonymous;
        //var uid = user.uid;
        //var providerData = user.providerData;
          
        return db.child('users').orderByChild('firebase_id').equalTo(user.uid)
          .on('value', (snap) => {
            if (snap.val() === null) {
              return db.child('pending_users').orderByChild('firebase_id').equalTo(user.uid)
                .on('value', (snap2) => {
                  let pen_users = snap2.val();
                  if (pen_users === null)
                    return;
                  let user_key = Object.keys(pen_users)[0];
                  let this_user = pen_users[user_key];
                  this_user['pending'] = true;
                  this.setState({'this_user': this_user,
                                  'this_user_loaded': true, 
                                  'this_user_found': true});
                });
            }
            
            let users = snap.val();
            let user_key = Object.keys(users)[0];
            let this_user = users[user_key];
            
            sara.database().ref('/main/users_sen/'+user_key+'/logged_in').set(true);            
            return db.child('users_sen/'+this_user.id)
              .on('value', (snap3) => {
                let sens_data = snap3.val();
                if(sens_data !== null) {
                  this_user['is_admin'] = sens_data['is_admin'];
                  
                  if (typeof sens_data['wants_courage'] === 'undefined' 
                              && !this.courage_modal_shown) { 
                    this.courage_modal_shown = true;
                    $('#courage_modal').modal('show');
                  }
                  
                  if (typeof sens_data['wants_courage'] !== 'undefined')
                    this_user['wants_courage'] = sens_data['wants_courage'];
                  
                  this_user['post_drafts'] = sens_data['post_drafts'];
                  let draft_list = [];
                  if (typeof this_user['post_drafts'] !== 'undefined') {
                    for (let did in this_user['post_drafts']) {
                      draft_list.push(this_user['post_drafts'][did]);
                    }
                    
                    draft_list.sort((b, a) => {
                      let a_time = a.updated_time || 0;
                      let b_time = b.updated_time || 0;
                      
                      return a_time - b_time;
                    });
                    let latest_draft = draft_list[0];
                    this_user['draft_list'] = draft_list;
                    this_user['latest_draft'] = latest_draft;
                  }
                  else {
                    this_user['draft_list'] = undefined;
                    this_user['latest_draft'] = undefined;
                  }
                }
                this.setState({'this_user': this_user, 
                              'this_user_loaded': true, 
                              'this_user_found': true});
              });
          });
          
      }
      else {
        // User is signed out.
        this.setState({'this_user': null, 'this_user_loaded': true, 'this_user_found': false});
      }
    });
    
    
    let posts_info = JSON.parse(localStorage.getItem('posts_info')) || [];
    let posts_info_dict = JSON.parse(localStorage.getItem('posts_info_dict')) || {};
    
    if (!this.state.posts_info_loaded) {
      this.setState({'posts_info': posts_info,
                      'posts_info_dict': posts_info_dict});
    }
    
    var db = sara.database().ref('main');
    db.child('posts').orderByChild('pub_time').limitToLast(15)
    .on('value', (snap) => {
      let posts_info = [];
      let posts_info_dict = {};
      
      let this_post = {};
      let this_post_serial = {};
      snap.forEach((snap) => {
        this_post = snap.val();
        
        this_post_serial = {
          'id': this_post.id,
          'title': this_post.title,
          'pub_time': this_post.pub_time,
          'num_comments': this_post.num_comments,
          'author': this_post.author,
          'author_name': this_post.author_name,
          'category': this_post.category,
        };
        posts_info.push(this_post_serial);
        posts_info_dict[this_post.id] = this_post_serial;
      });
      posts_info.reverse();
      if (!this.state.posts_info_loaded) {
        this.setState({'posts_info': posts_info,
                        'posts_info_dict': posts_info_dict});
      }
      localStorage.setItem('posts_info', JSON.stringify(posts_info));
      localStorage.setItem('posts_info_dict', JSON.stringify(posts_info_dict));
    });
    db.child('posts').orderByChild('pub_time').on('value', (snap) => {
      let posts_info = [];
      let posts_info_dict = {};
      
      let this_post = {};
      let this_post_serial = {};
      snap.forEach((snap) => {
        this_post = snap.val();
        
        this_post_serial = {
          'id': this_post.id,
          'title': this_post.title,
          'pub_time': this_post.pub_time,
          'num_comments': this_post.num_comments,
          'author': this_post.author,
          'author_name': this_post.author_name,
          'category': this_post.category,
        };
        posts_info.push(this_post_serial);
        posts_info_dict[this_post.id] = this_post_serial;
      });
      this.setState({'posts_info': posts_info.reverse(), 
                        'posts_info_loaded': true,
                        'posts_info_dict': posts_info_dict});
    });
    /*
    db.child('users').orderByChild('active').equalTo(true).on('value', (snap) => {
      let data = snap.val();
      let this_user;
      let for_db = {};
      for(var uid in data){
        this_user = data[uid];
        let post_list = [];
        for (var pid in this_user.posts){
          post_list.push(this_user.posts[pid]);
        }
        post_list.sort((b, a) => {
          return a.pub_time - b.pub_time;
        });
        
        for_db[uid] = {
          'id': uid,
          'active': this_user.active,
          'fav_categories': this_user.fav_categories,
          'helper_points': this_user.helper_points,
          'name': this_user.name,
          'post_list': post_list
        };
      }
      
      this.setState({'users': for_db, 'users_loaded': true});
    });
    */
    db.child('blog_posts').orderByChild('pub_time').on('value', (snap) => {
      let blogs = [];
      
      let this_blog;
      snap.forEach((snap2) => {
        this_blog = snap2.val();
        
        blogs.push(this_blog);
      });
      blogs.reverse();
      this.setState({'blogs': blogs, 'blogs_dict':snap.val(), 'blogs_loaded': true});
    });
    
    
    function handle_hash() {
      if (window.location.hash !== ''){
        let hash = window.location.hash.substring(1);
        if (hash === 'login') 
          $('#login_modal').modal('show');
        else if (hash === 'register') 
          $('#reg_modal').modal('show');
      }
    }
    handle_hash();
    $(window).on('hashchange', handle_hash);
    
    
    $('#courage_modal').on('hidden.bs.modal', () => {
      if (!this.courage_action_taken) {
        if (this.state.this_user)
          sara.database().ref('/main/users_sen/'+this.state.this_user.id+'/wants_courage')
            .set(false)
            .then(() => {
              $('#alert_dark').text('You will not receive weekly encouragement emails')
                  .fadeIn().delay(4000).fadeOut();
            })
      }
    });    
  }
  courage_action_taken = false;
  courage_modal_shown = false;
  
  logout() {
    sara.database().ref('/main/users_sen/'+this.state.this_user.id+'/logged_in').set(false)
      .then(() => {
        sara.auth().signOut().then(function() {
          $('#alert_dark').text('You are logged out').fadeIn().delay(1600).fadeOut();
        }).catch(function(error) {
          console.log(error);
        });
      })
      .catch((error) => {
        console.log(error);
        sara.auth().signOut().then(function() {
          $('#alert_dark').text('You are logged out').fadeIn().delay(1600).fadeOut();
        }).catch(function(error) {
          console.log(error);
        });
      });
  }
  
  path = '';
  handle_route_change() {
    if (this.path !==  window.location.href.split(window.location.host)[1]) {
      // on page change (doesn't work on first load)
      this.path = window.location.href.split(window.location.host)[1];
      gtag('config', 'UA-47559881-1', {'page_path': this.path});
    }
    else
      this.path = window.location.href.split(window.location.host)[1];
    
    $('#tab_btns t').removeClass('active');
    let page = (this.path.split('/')[1]||'').toLowerCase();
    console.log(page)
    switch (page) {
      case 'about':
        $('#about_tab_btn').addClass('active');
        break;
      case 'blog':
        $('#blog_tab_btn').addClass('active');
        break;
    }
  }
  
  render() {
    let banner_btns = [];
    if (this.state.this_user_loaded){
      if(this.state.this_user === null)
        banner_btns = [
          <t onClick={() => $('#login_modal').modal('show')} className="banner_link">
            Login
          </t>,
          <t onClick={() => $('#reg_modal').modal('show')} className="banner_link">
            Register
          </t>
        ];
      else {
        if (this.state.this_user_found) {
          banner_btns.push(<Link to={"/user/"+this.state.this_user.id}> 
            <t id="user_link" className="banner_link">{this.state.this_user.name}</t>
          </Link>);
        }
        if (this.state.this_user.is_admin) {          
          banner_btns.push(<Link to={"/admin"}> 
            <t id="admin_link" className="banner_link">Admin</t>
          </Link>);
        }
        banner_btns.push(
          <t onClick={this.logout.bind(this)} className="banner_link">
            Logout
          </t>
        );
      }
    }
    else {
      banner_btns.push(<t className="banner_link">Loading...</t>);
    }
    /*
    let suicide_link = null;
    let path_list = window.location.pathname.split('/');
    if ((path_list[1]||'').toLowerCase() === 'category'
            && (path_list[2]||'').toLowerCase() === 'suicide') 
      suicide_link =           
        <p style={{"marginTop": "40px"}}> 
          National Suicide Prevention Hotline: &nbsp;
            <a href="tel:1-800-273-8255">1-800-273-8255</a>
        </p>;
                  */
    let logged_in = this.state.this_user !== null;
    
    return (
      <Router>
        <div className={"App "+(logged_in?"logged_in":"not_logged_in")}>
          <div className="container-fluid">
          
            <Route path="/" render={() => {
              this.handle_route_change();
              return <header className="App-header">
                <Link to="/" className="app_logo_holder">
                  <img src={logo} className="App-logo" alt="logo" />
                </Link>
                <div id="tab_btns">
                  <Link to="/about"><t id="about_tab_btn">About</t></Link>
                  <Link to="/blog"><t id="blog_tab_btn">Blog</t></Link>
                  <a href="https://www.psychologytoday.com/us"><t>Find a Therapist</t></a>
                  <a href="https://teespring.com/stores/minus-the-negative-store"><t>Store</t></a>
                </div>
                <t id="banner_btn_cont">
                  {banner_btns}
                </t>
              </header>;
            }} />
            
            <Switch>
            <Route exact path="/" render={() => (
              <div className="row">
                <div className="col-md-7">
                  <CatLinks/>
                </div>
                <div className="col-md-5">
                  <Feed app_state={this.state}/>
                </div>
              </div>
            )} />
            
            <Route path="/category" render={() => {
              let this_cat = window.location.pathname.split('/')[2].toLowerCase();
              // TODO: image ratio (class)?
              if (typeof cat_names[this_cat] === 'undefined')
                return <h3>Category not found</h3>;
              
              let suicide_msg = null;
              if (this_cat === 'suicide') {
                suicide_msg = <p> 
                  National Suicide Prevention Hotline: &nbsp;
                    <a href="tel:1-800-273-8255">1-800-273-8255</a>
                </p>;
              }
              return <div>
                <img src={"/images/"+this_cat+".png"} alt={cat_names[this_cat]}
                            style={{"marginBottom": "5px", "max-width": "100%"}} />
                            
                {suicide_msg}
                <div className="row" style={{"marginTop": "35px"}}>
                  <div className="col-md-6">
                    <img src={"/images/speakyourmind.png"} style={{"max-width": "100%"}}
                                alt="speak your mind"/>
                    <br/>
                    <div id="cat_make_cont">
                      <MakePost app_state={this.state}/>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <Feed app_state={this.state}/>
                  </div>
                </div>      
              </div>;
            }}/>
            
            <Route path="/user" render={(props) => (
              <User app_state={this.state}  {...props}/>
            )}/>            
            <Route path="/post" render={() => (
              <Post app_state={this.state}/>
            )}/>
            <Route path="/admin" render={() => (
              <Admin app_state={this.state}/>
            )}/>
            <Route path="/blog/:bid" render={() => (
              <ViewBlog app_state={this.state}/>
            )}/>
            <Route exact path="/blog" render={() => (
              <AllBlog app_state={this.state}/>
            )}/>
            <Route path="/(about|privacy|terms)/" render={() => (
              <Extras />
            )}/>
            <Route render={() => (
              [<h3>This page does not exist</h3>,
              <Link to="/">Click here to go home</Link>]
            )}/>
            </Switch>
                       
            <div id="bottom_links">
              <Link to="/terms"><t>Terms</t></Link>&nbsp;/&nbsp;<Link to="/privacy"><t>Privacy</t></Link>
            </div>
            
            <Login app_state={this.state} />
            <Register app_state={this.state}/>
            
            <div id="alert_working" className="alert alert-dark" role="alert">Working...</div>
            <div id="alert_primary" className="alert alert-primary" role="alert"></div>
            <div id="alert_secondary" className="alert alert-secondary" role="alert"></div>
            <div id="alert_success" className="alert alert-success" role="alert">Success</div>
            <div id="alert_danger" className="alert alert-danger" role="alert">Error</div>
            <div id="alert_warning" className="alert alert-warning" role="alert"></div>
            <div id="alert_info" className="alert alert-info" role="alert"></div>
            <div id="alert_light" className="alert alert-light" role="alert"></div>
            <div id="alert_dark" className="alert alert-dark" role="alert"></div>
            <div id="alert" className="alert alert-dark" role="alert"></div>
            <div id="reg_alert" className="alert alert-dark alert-dismissible fade show" role="alert">
              <strong>Registerd!</strong> Please give us a minute to setup your account. You will be automatically signed in afterwards.
              <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            
            <div id="courage_modal" className="modal fade" tabindex="-1" role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Encouragement Emails</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                
                <div className="modal-body">
                  <p>
                    Would you like to receive weekly encouragement emails?
                  </p>
                </div>
                
                <div style={{'margin-top': '10px'}} className="modal-footer">
                  <button type="button" className="btn btn-dark"
                            onClick={()=>{
                              if (this.state.this_user)
                                sara.database().ref('/main/users_sen/'+this.state.this_user.id+'/wants_courage')
                                  .set(true)
                                  .then(() => {
                                    $('#alert_dark').text('You will receive weekly encouragement emails')
                                        .fadeIn().delay(4000).fadeOut();
                                    this.courage_action_taken = true;
                                    $('#courage_modal').modal('hide');
                                  })
                                  .catch((error) => {
                                    $('#alert_danger').text(error.message)
                                        .fadeIn().delay(3000).fadeOut();
                                  });
                              else 
                                $('#courage_modal').modal('hide');
                            }}>Yes</button>
                  <button type="button" className="btn btn-outline-danger"
                            onClick={()=>{                              
                              if (this.state.this_user)
                                sara.database().ref('/main/users_sen/'+this.state.this_user.id+'/wants_courage')
                                  .set(false)
                                  .then(() => {
                                    $('#alert_dark').text('You will not receive weekly encouragement emails')
                                        .fadeIn().delay(4000).fadeOut();
                                    this.courage_action_taken = true;
                                    $('#courage_modal').modal('hide');
                                  })
                                  .catch((error) => {
                                    $('#alert_danger').text(error.message)
                                        .fadeIn().delay(3000).fadeOut();
                                  });
                              else 
                                $('#courage_modal').modal('hide');
                            }}>No</button>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </Router>
    );
  }
}

export default App;


const cat_names = {
  'relationships': 'Relationships',
  'mentalhealth': 'Mental Health',
  'sexualorientation': 'Sexual Orientation',
  'loss': 'Loss',
  'race': 'Race',
  'suicide': 'Suicide',
  'abuse': 'Abuse',
  'addiction': 'Addiction',
  'eatingdisorders': 'Eating Disorders',
  'miscellaneous': 'Miscellaneous',
  'religion': 'Religion',
}


// WEBPACK FOOTER //
// ./src/App.js